<template>
  <video ref="video" :src="src" autoplay playsinline muted loop class="video" />
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    src: {
      type: String,
      default: ''
    }
  },

  created () {
    this.$hub.on('homepage:video', this.onPlay)
  },

  beforeDestroy () {
    this.$hub.off('homepage:video', this.onPlay)
  },

  methods: {
    onPlay () {
      this.$refs.video.play()
    }
  }
}

</script>

<style lang="stylus">

</style>